import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import React from 'react';
import _isNil from 'lodash/isNil';
import { getPriceDisplay } from '../../services/price';
import { PricePropType, PricePropTypeDefault, PriceSettingsPropType, PriceSettingsPropTypeDefault } from '../../types';
import './Price.css';
var defaultProps = _objectSpread(_objectSpread({}, PricePropTypeDefault), PriceSettingsPropTypeDefault);
function Price(_ref) {
  var amount = _ref.amount,
    precision = _ref.precision,
    displayZeroCost = _ref.displayZeroCost,
    hideCurrencySign = _ref.hideCurrencySign,
    hide = _ref.hide;
  if (_isNil(amount)) {
    return null;
  }
  if (hide) {
    return null;
  }
  var formattedAmount = getPriceDisplay(amount, {
    precision: precision,
    displayZeroCost: displayZeroCost,
    hideCurrencySign: hideCurrencySign
  });
  if (_isNil(formattedAmount) || formattedAmount === '') {
    return null;
  }
  return /*#__PURE__*/React.createElement("span", {
    className: "price-container"
  }, formattedAmount);
}
Price.defaultProps = defaultProps;
export default Price;